export default {
  subAccounts: [],
  isCreatingSubAccount: false,
  isDeletingSubAccount: false,
  isResettingPassword: false,
  isChangingPassword: false,
  subAccountLimit: null,
  errors: {
    create: null,
    delete: null,
    resetPassword: null,
    changePassword: null,
  },
};
